import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest } from '../components/auth/authConfig';
import { msalInstance } from '../components/auth/msalInstance';

/**
 * Access token for streaming (shared MSAL instance with the rest of the app).
 */
export const getAccessToken = async () => {
    const account = msalInstance.getAllAccounts()[0];

    if (!account) {
        throw new Error('No active account found');
    }

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: account
        });
        return response.accessToken;
    } catch (error) {
        const needsInteraction =
            error instanceof InteractionRequiredAuthError ||
            error.errorCode === 'interaction_required' ||
            error.errorCode === 'consent_required' ||
            error.errorCode === 'login_required' ||
            error.errorCode === 'invalid_grant';
        if (needsInteraction) {
            try {
                msalInstance.removeAccount(account);
                const remaining = msalInstance.getAllAccounts();
                msalInstance.setActiveAccount(remaining[0] ?? null);
            } catch {
                /* ignore */
            }
        } else if (process.env.NODE_ENV === 'development') {
            console.error('Error acquiring token:', error);
        }
        throw error;
    }
}; 